import React from "react";
import { useSiteContent } from "@/contexts/SiteContentContext";
import { HOME } from "@/lib/homeContent";
import { ScheduleCallButton } from "@/components/ScheduleCallButton";

const IMG = "/img/home-final.jpg";

export default function FinalCta() {
  const { section } = useSiteContent();
  const c = section("final_cta", HOME.final_cta);

  return (
    <section id="booking" data-testid="final-cta-section" className="relative bg-[#0D231B] text-white overflow-hidden">
      <img src={IMG} alt="An evening in a residential plaza in Spain" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(13,35,27,0.92) 0%, rgba(13,35,27,0.75) 55%, rgba(43,16,23,0.55) 100%)" }} />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-28 md:py-40">
        <div className="max-w-2xl">
          <h2 data-testid="final-cta-headline" className="text-4xl md:text-6xl leading-[1.02] tracking-tight" style={{ fontFamily: "Kanit, Arial, sans-serif", fontWeight: 600 }}>
            {c.headline}
          </h2>
          <p className="mt-7 text-white/85 text-lg md:text-xl leading-relaxed" style={{ fontFamily: "'Noto Serif', Georgia, serif" }}>
            {c.text}
          </p>
          <div className="mt-10">
            <ScheduleCallButton label={c.cta} source="final_cta" tone="sand" testId="final-cta-button" />
          </div>
        </div>
      </div>
    </section>
  );
}
